<template>
	<ul class="rsv_user_info">
		<li v-show="!isEditBasicInfo">
			<span class="name">{{ name }}</span>
			<span class="chartnum" v-if="usingChartNumber">({{ chartNumber }})</span>
			<span class="gen_birth">{{ gender }}/{{ birth }}</span>
			<span class="label lblue" v-if="usingFirstVisitStartDate == true && isFirstVisit == true">{{
				$t('common.initial') }}</span>
			<span class="label lgray2" v-if="usingFirstVisitStartDate == true && isFirstVisit == false">{{
				$t('common.return') }}</span>
			<span class="left_btn_group">
				<button class="btn btn_xs btn_white btn_icon2" v-if="!isReservationOnly"
					@click="setEditBasicInfo(true)"><v-icon
						small>mdi-pencil</v-icon></button>
				<button class="btn btn_xs btn_white btn_icon2 " v-if="!isReservationOnly"
					@click="action_ShowDetail"><v-icon small>mdi-account</v-icon></button>
			</span>
		</li>
		<li v-show="!isEditBasicInfo">
			<div class="phonenum">
				<div class="title_s">{{ $t('popup_user_reservation.label_phone') }}</div>
				<div class="txt_s">{{ phoneNumber }}</div>

			</div>
			<div class="patient_tag" v-if="usingUserTag">
				<div class="title_s">{{ $t('popup_user_reservation.label_patient_tag') }}</div>
				<div class="txt_s">
					<div class="tag_group" v-for="tag in tags" :key="tag._id">
						<span class="label lgray2">{{ tag.name }}</span>
					</div>
					<button :disabled="isReservationOnly"><v-icon small
							@click.prevent="action_ShowEditTag">mdi-pencil</v-icon></button>
					<EditTag :isShow="isEditTag" :selectedService="hservice" @action_HideTag="hideEditTag" />
				</div>
			</div>
			<button class="btn_ico" v-if="isWindow == false" :disabled="canChat == false"
				@click="action_Chat"><v-icon>mdi-chat</v-icon></button>
		</li>
		<EditReservationUserNote ref="EditReservationUserNote" :isShow="!isEditBasicInfo" :hservice="hservice"
			:reservationUserNote="reservationUserNote" :noteContent="noteContent" @input="updateNoteContentValue"
			@editing-status-changed="handleNoteEditingStatusChanged" />

		<EditBasicInfo ref="EditBasicInfo" :isShow="isEditBasicInfo" :hservice="hservice" :noteContent="noteContent"
			@closeEditBasicInfo="setEditBasicInfo(false)" />
	</ul>
</template>


<script>
import { formatGenderShort } from '@/util/format-gender'
import { formatPhoneHyphen } from '@/util/format-phone'
import { toBirth6String } from '@/util/format-birth'
import { ipcRenderer } from "electron";
import { mapState } from "vuex";

import EditBasicInfo from "./EditUserBasicInfo.vue";
import EditReservationUserNote from "./EditReservationUserNote.vue";
import EditTag from "@/v2/views/Main/ShareComponents/ParameterPannels/tag";
import { editGuardState, setEditBasicInfo } from "../../../ReservationPopup/popup-edit-guard";
import { handleRefresh } from "../../../../../sheet-refresh";

export default {
	components: { EditTag, EditBasicInfo, EditReservationUserNote },
	props: {
		hservice: Object,
		note: String,
		reservationUserNote: Object,
	},
	data() {
		return {
			isLoading: false,
			noteContent: undefined,
			isEditTag: false,
			isNoteEditing: false,

			editGuard: editGuardState,
		};
	},
	watch: {
		note: {
			immediate: true,
			handler: function (newValue) {
				if (this.isNoteEditing == false) {
					this.noteContent = newValue
				}
			}
		}
	},
	computed: {
		...mapState(["SaaS"]),
		isWindow: function () {
			return this.SaaS.isWindow ?? false;
		},
		isEditBasicInfo: function () {
			return this.editGuard.isEditBasicInfo;
		},
		usingUserTag: function () {
			return this.servicesetting?.setting?.usingUserTag ?? false;
		},
		usingChartNumber: function () {
			return this.servicesetting?.setting?.usingChartNumber ?? false;
		},
		usingFirstVisitStartDate: function () {
			return this.servicesetting?.setting?.usingFirstVisitStartDate ?? false;
		},
		isReservationOnly: function () {
			return this.hservice?.isUnregisteredUser ?? false;
		},
		hserviceID: function () {
			return this.hservice?._id ?? "";
		},
		userID: function () {
			return this.hservice?.userID ?? "";
		},
		name: function () {
			return this.hservice?.name ?? "-";
		},
		chartNumber: function () {
			return this.hservice?.chartNumber ?? "";
		},
		gender: function () {
			const genderStr = formatGenderShort(this.hservice?.gender) ?? "-";
			if (genderStr === '-') {
				return '-';
			}
			return genderStr === '남' ? this.$t('common.male_short') : this.$t('common.female_short');
		},
		birth: function () {
			return toBirth6String(this.hservice?.birth) ?? "-";
		},
		isFirstVisit: function () {
			return this.hservice?.isFirstVisit;
		},
		countries: function () {
			const list = this.$store.state.servicesetting.countries;
			return Array.isArray(list) ? list : [];
		},
		countryCodeId() {
			// KR fallback 을 두지 않는다 — 국가코드가 없으면 접두 없이 국내 포맷으로 표시 (기존 동작)
			return this.hservice?.countryCode?._id;
		},
		countryDialingCode() {
			if (!this.isWindow) return "";

			const code = this.hservice?.countryCode?.internationalDialingCodes;
			if (code) {
				return `(+${code})`;
			}

			// 국가 목록 API 는 _id 를 countryId 로 리네임해 내려준다
			const country = this.countries.find(c => c.countryId == this.countryCodeId);
			if (country) {
				return `(+${country.internationalDialingCodes})`;
			}
			return "";
		},
		phoneNumber() {
			const phoneRaw = this.hservice?.phone;
			if (!phoneRaw) return "-";

			if (this.countryDialingCode) {
				return `${this.countryDialingCode} ${phoneRaw}`;
			}
			return formatPhoneHyphen(phoneRaw) || "-";
		},
		tags: function () {
			return this.hservice?.userTagIDs ?? [];
		},
		canChat: function () {
			return (
				this.hservice?.isRun == true && this.hservice?.closeReason?.length == 0
			);
		},
	},
	methods: {
		// 템플릿에서 호출할 수 있도록 popup-edit-guard 의 함수를 메서드로 노출
		setEditBasicInfo,
		action_ShowDetail() {
			ipcRenderer.send('Application.moveToPage', {
				action: 'openCustomerDetail',
				patientId: this.hservice._id,
			})
		},
		updateNoteContentValue(content) {
			this.noteContent = content;
		},
		handleNoteEditingStatusChanged(isEditing) {
			this.isNoteEditing = isEditing;
		},
		action_ShowEditTag() {
			this.showEditTag();
		},
		async action_Chat() {
			let model = {
				serviceID: this.hservice._id,
				name: this.hservice.name,
			};
			let modelString = JSON.stringify(model);
			ipcRenderer.send("Application.v1ShowChatWindow", {
				componentName: "UserChat",
				paramString: modelString,
			});
		},
		showEditTag() {
			this.isEditTag = true;
		},
		hideEditTag(isUpdated) {
			this.isEditTag = false;
			if (isUpdated) {
				handleRefresh();
			}
		},
	},
};
</script>